import React, { useEffect, useRef, useState } from 'react';
import "./Display.css";
import "./Cerebri-Sans-Book.ttf";
import "./Cerebri-Sans-Bold.ttf";
import "./Cerebri-Sans-Regular.ttf";
import Logo from "./Standard Logo - Horizontal.svg";
import QRCode from "./AllergensLink.png";
import NCASS_LOGO from "./NCASS-LOGO.jpg";
import FOOD_HYGINE_RATING from "./FHR.svg";
// import Snowfall from 'react-snowfall';
import HeadingGif from './gifs/heading.gif';
import BouncyCastlesVideo from './gifs/BouncyCastles.mp4';
import MascotsVideo from './gifs/Mascots.mp4';
import Category from "./components/Category";
import { donuts, drinks, icecream, sweetTreats, snacks, toys } from "./items";
import { preloadMediaAssets } from './preloadMediaAssets';

const SLIDE_INTERVAL_MS = 10000;
const VIDEO_FALLBACK_TIMEOUT_MS = 20000;

const Display = () => {
  const [activeSlide, setActiveSlide] = useState('menu');
  const [mediaReady, setMediaReady] = useState(false);
  const [loadProgress, setLoadProgress] = useState({ loaded: 0, total: 1, percent: 0 });
  const bouncyCastlesVideoRef = useRef(null);
  const mascotsVideoRef = useRef(null);

  useEffect(() => {
    let isMounted = true;

    preloadMediaAssets({ onProgress: setLoadProgress }).finally(() => {
      if (isMounted) {
        setMediaReady(true);
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (!mediaReady) {
      return undefined;
    }

    if (activeSlide !== 'menu') {
      return undefined;
    }

    const timeout = setTimeout(() => {
      setActiveSlide('bouncy-castles');
    }, SLIDE_INTERVAL_MS);

    return () => clearTimeout(timeout);
  }, [activeSlide, mediaReady]);

  useEffect(() => {
    if (activeSlide !== 'bouncy-castles' && activeSlide !== 'mascots') {
      return undefined;
    }

    const nextSlide = activeSlide === 'bouncy-castles' ? 'mascots' : 'menu';
    const video = activeSlide === 'bouncy-castles'
      ? bouncyCastlesVideoRef.current
      : mascotsVideoRef.current;
    const fallbackTimeout = setTimeout(() => {
      setActiveSlide(nextSlide);
    }, VIDEO_FALLBACK_TIMEOUT_MS);

    if (!video) {
      return () => clearTimeout(fallbackTimeout);
    }

    video.pause();
    video.currentTime = 0;
    video.play().catch(() => {
      setActiveSlide(nextSlide);
    });

    return () => {
      clearTimeout(fallbackTimeout);
      video.pause();
    };
  }, [activeSlide]);

  if (!mediaReady) {
    return (
      <div className="display-loading">
        <img src={Logo} alt="Blue Duo Catering Logo" className="display-loading-logo" />
        <div className="display-loading-panel">
          <p className="display-loading-label">Loading display</p>
          <div className="display-loading-bar" aria-hidden="true">
            <div
              className="display-loading-bar-fill"
              style={{ width: `${loadProgress.percent}%` }}
            />
          </div>
          <p className="display-loading-count">
            {loadProgress.loaded} / {loadProgress.total} files
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="display-container">
      <div className="main-content">
        <img className='heading-gif' src={HeadingGif} alt="Blue Duo heading" />

        <div className="display-carousel">
          <div
            className={`display-slide display-slide-menu ${activeSlide === 'menu' ? 'is-active' : ''}`}
            aria-hidden={activeSlide !== 'menu'}
          >
            <div className="category-container">
              <div className='container-row'>
                <Category title="Donuts" products={donuts} />
                <Category title="Ice Cream" products={icecream} />
                <Category title="Snacks" products={snacks} />
                <Category title="Drinks" products={drinks} />
                
              </div>

              <div className='container-row'>
                <Category title="Toys" products={toys} />
                {/*<img className='payment-options' src={paymentOptions} alt="Payment options" /> */}
              </div>

              <div className='container-row'>
                <Category title="Sweet Treats" products={sweetTreats} />
                
              </div>
              

            </div>
          </div>

          <div
            className={`display-slide display-slide-gif ${activeSlide === 'bouncy-castles' ? 'is-active' : ''}`}
            aria-hidden={activeSlide !== 'bouncy-castles'}
          >
            <video
              ref={bouncyCastlesVideoRef}
              className="central-carousel-gif"
              src={BouncyCastlesVideo}
              aria-label="Bouncy castles"
              muted
              playsInline
              preload="auto"
              onEnded={() => setActiveSlide('mascots')}
              onError={() => setActiveSlide('mascots')}
            />
          </div>

          <div
            className={`display-slide display-slide-gif ${activeSlide === 'mascots' ? 'is-active' : ''}`}
            aria-hidden={activeSlide !== 'mascots'}
          >
            <video
              ref={mascotsVideoRef}
              className="central-carousel-gif"
              src={MascotsVideo}
              aria-label="Mascots"
              muted
              playsInline
              preload="auto"
              onEnded={() => setActiveSlide('menu')}
              onError={() => setActiveSlide('menu')}
            />
          </div>

        </div>
      </div>

      {/* Bottom Banner */}
      <div className="bottom-banner">
        <div className="contact-details">
          <img src={Logo} alt="Blue Duo Catering Logo" className="footer-logo" />
          <p>Email: contact@blueduo.events</p>
          <p>Phone: 01352 372235</p>
          <p>Website: www.blueduo.events</p>
        </div>
        <div className="food-hygine-rating">
          <img src={FOOD_HYGINE_RATING} alt="5 Star Food Hygine Rating" />
        </div>
        <div className="ncass-logo">
          <img src={NCASS_LOGO} alt="NCASS Logo" />
        </div>
        <div className="qr-code">
          <img src={QRCode} alt="Scan for allergen details" />
          <p>Allergy Info</p>
        </div>
      </div>
    </div>
  );
};

export default Display;
